import {Component, model, ModelSignal} from '@angular/core';
import {
  CSV_IMPORT_ACTION,
  DEFAULT_TABLE_ACTIONS,
  ITableAction,
  TableControlComponent,
  TableControlModule,
} from 'frontier/browserkit';
import AppControlGuids from '../../../api/ControlGuids';

@Component({
  selector: 'app-business-areas-table',
  templateUrl: '../../../../../projects/frontier/browserkit/src/lib/components/control/table-control/table-control.component.html',
  styleUrl: '../../../../../projects/frontier/browserkit/src/lib/components/control/table-control/table-control.component.scss',
  standalone: true,
  imports: [TableControlModule],
})
export class BusinessAreasTableComponent extends TableControlComponent {
  override GUID: string = AppControlGuids.TBusinessAreaMappingTable;
  override actions: ModelSignal<ITableAction[]> = model<ITableAction[]>([
    ...DEFAULT_TABLE_ACTIONS,
    CSV_IMPORT_ACTION,
  ]);
}
